export default __webpack_public_path__ + "static/media/text.169867e5.md";